import React from "react";
import Header from "components/header/Header";
import Footer from "components/footer/Footer";
import DashboardHeroSection from "components/dashboard/DashboardHeroSection";
import OrdersTable from "components/dashboard/orders-table/OrdersTable";
import UserAuth from "components/AuthGaurd/UserAuth";

const Orders = () => {
  return (
    <UserAuth>
      <div className="tw-relative">
        <header>
          <Header admin={true} />
        </header>
        <section>
          <DashboardHeroSection title="Orders">{<OrdersTable />}</DashboardHeroSection>
        </section>

        <footer className="tw-flex">
          <Footer />
        </footer>
      </div>
    </UserAuth>
  );
};

export default Orders;
